// Shared bits for the Capital Markets Fundings screen: the local palette (the
// same restrained light theme the closing calendars use), stat cards, and the
// loan-link helper that only navigates for loans that live in THIS LOS.
import { Box } from "@mui/material";

import Flx from "../../components/layout/Flx";
import Txt from "../../components/typography/Txt";
import { slate, status } from "../../theme/colors";

export const C = {
  bg: "#f7f8fa",
  surface: "#ffffff",
  ink: slate[900],
  sub: slate[600],
  faint: slate[400],
  line: "#e6e9ee",
  lineSoft: "#eef1f5",
};

export const MONO = "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace";

// The portal id the backend stamps on records it owns (`glv.PORTAL_ID`,
// defaulting to "eastview"). A funding record from the other LOS can't be
// opened here — its dealId only exists in that portal's database.
export const THIS_LOS = process.env.REACT_APP_PORTAL_ID || "eastview";
export const isThisLos = (rec) => !rec?.originatingLos || rec.originatingLos === THIS_LOS;

// Drilldown URL for a record, or null when it isn't ours to open.
export const loanHref = (rec) => {
  if (!rec?.dealId || !isThisLos(rec)) return null;
  const base = rec?.pipeline === "acquisition" ? "/acquisition" : "/loan";
  return `${base}/${rec.dealId}/closing`;
};

export const StatCard = ({ label, value, sub, alert, sx }) => (
  <Box
    sx={{
      background: C.surface,
      border: `1px solid ${C.line}`,
      borderRadius: "10px",
      px: 2,
      py: 1.5,
      boxShadow: "0 1px 2px rgba(20,30,50,.06)",
      minWidth: 0,
      ...sx,
    }}
  >
    <Txt
      sx={{
        fontSize: 11,
        fontWeight: 600,
        color: C.faint,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        display: "block",
      }}
    >
      {label}
    </Txt>
    <Txt
      sx={{
        fontSize: 20,
        fontWeight: 700,
        letterSpacing: "-0.01em",
        color: alert ? status.error.fg : C.ink,
        display: "block",
        mt: 0.25,
      }}
    >
      {value}
    </Txt>
    {sub && (
      <Txt sx={{ fontSize: 11.5, color: C.sub, display: "block", mt: 0.25 }}>{sub}</Txt>
    )}
  </Box>
);

// Full-height centred cell for any non-text AG Grid renderer (house rule).
export const CenterCell = ({ children, left }) => (
  <Flx ac jc={left ? undefined : true} sx={{ height: "100%", width: "100%", minWidth: 0 }}>
    {children}
  </Flx>
);

export const pct = (p) => (p == null ? "—" : `${Math.round(Number(p) * 100)}%`);
